document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('#MobileMenu');
  const open = document.querySelector('.menu-toggle');
  const close = document.querySelector('.menu-close');
  open?.addEventListener('click', () => {
    menu.hidden = false;
    open.setAttribute('aria-expanded', 'true');
  });
  close?.addEventListener('click', () => {
    menu.hidden = true;
    open.setAttribute('aria-expanded', 'false');
  });

  document.querySelectorAll('.video-hero').forEach((hero) => {
    const video = hero.querySelector('video');
    const button = hero.querySelector('.sound-toggle');
    button?.addEventListener('click', () => {
      video.muted = !video.muted;
      button.textContent = video.muted ? 'Sound on' : 'Sound off';
      button.setAttribute('aria-label', video.muted ? 'Turn video sound on' : 'Mute video');
    });
  });

  const categoryButtons = document.querySelectorAll('[data-category-filter]');
  const categoryProducts = document.querySelectorAll('[data-category-product]');
  const categoryEmpty = document.querySelector('[data-category-empty]');

  categoryButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const category = button.dataset.categoryFilter;
      let visibleProducts = 0;

      categoryButtons.forEach((tab) => {
        const isActive = tab === button;
        tab.classList.toggle('category-tabs__link--active', isActive);
        tab.setAttribute('aria-pressed', String(isActive));
      });

      categoryProducts.forEach((product) => {
        const isVisible = product.dataset.categoryProduct === category;
        product.hidden = !isVisible;
        if (isVisible) visibleProducts += 1;
      });

      if (categoryEmpty) categoryEmpty.hidden = visibleProducts > 0;
    });
  });

  const requestedCategory = new URLSearchParams(window.location.search).get('category');
  const requestedButton = Array.from(categoryButtons).find(
    (button) => button.dataset.categoryFilter === requestedCategory
  );
  requestedButton?.click();

  document.querySelectorAll('.product-recommendations[data-url]').forEach(async (section) => {
    try {
      const response = await fetch(section.dataset.url);
      if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const recommendations = html.querySelector('.product-recommendations');
      if (!recommendations?.querySelector('.complementary-products')) {
        section.remove();
        return;
      }

      const heading = recommendations.querySelector('.complementary-products h2');
      if (heading && section.dataset.heading) heading.textContent = section.dataset.heading;
      section.innerHTML = recommendations.innerHTML;
      section.hidden = false;
    } catch (error) {
      console.warn('Could not load related product recommendations.', error);
      section.remove();
    }
  });

  const cookieBanner = document.querySelector('[data-cookie-banner]');
  const cookiePanel = document.querySelector('[data-cookie-panel]');
  const cookieExpand = document.querySelector('[data-cookie-expand]');
  const cookieCollapse = document.querySelector('[data-cookie-collapse]');
  const cookieAccept = document.querySelector('[data-cookie-accept]');
  const cookieDecline = document.querySelector('[data-cookie-decline]');
  const cookieStatus = document.querySelector('[data-cookie-status]');
  const cookieTabLabel = document.querySelector('[data-cookie-tab-label]');

  if (cookieBanner && cookiePanel && cookieExpand) {
    const setExpanded = (expanded) => {
      cookiePanel.hidden = !expanded;
      cookieExpand.setAttribute('aria-expanded', String(expanded));
      cookieBanner.classList.toggle('cookie-banner--expanded', expanded);
    };

    const hasConsentDecision = (consent) =>
      consent && ['analytics', 'marketing', 'preferences'].some(
        (key) => consent[key] === 'yes' || consent[key] === 'no'
      );

    const showStatus = (message) => {
      if (!cookieStatus) return;
      cookieStatus.textContent = message;
      cookieStatus.hidden = false;
    };

    const saveConsent = (consent) => {
      const privacyApi = window.Shopify?.customerPrivacy;
      if (!privacyApi?.setTrackingConsent) {
        showStatus('Cookie settings are temporarily unavailable. Please try again.');
        return;
      }

      privacyApi.setTrackingConsent(consent, (error) => {
        if (error) {
          showStatus('Cookie settings are temporarily unavailable. Please try again.');
          return;
        }
        if (cookieTabLabel) cookieTabLabel.textContent = 'Cookie settings';
        setExpanded(false);
      });
    };

    cookieExpand.addEventListener('click', () => {
      setExpanded(cookiePanel.hidden);
    });
    cookieCollapse?.addEventListener('click', () => setExpanded(false));
    cookieAccept?.addEventListener('click', () => {
      saveConsent({ analytics: true, marketing: true, preferences: true });
    });
    cookieDecline?.addEventListener('click', () => {
      saveConsent({ analytics: false, marketing: false, preferences: false });
    });

    const loadPrivacyApi = () => {
      if (window.Shopify?.customerPrivacy) {
        if (hasConsentDecision(window.Shopify.customerPrivacy.currentVisitorConsent())) {
          if (cookieTabLabel) cookieTabLabel.textContent = 'Cookie settings';
        }
        return;
      }

      if (!window.Shopify?.loadFeatures) {
        showStatus('Cookie settings are temporarily unavailable. Please try again.');
        return;
      }

      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => {
          if (error) {
            showStatus('Cookie settings are temporarily unavailable. Please try again.');
            return;
          }
          if (hasConsentDecision(window.Shopify.customerPrivacy.currentVisitorConsent())) {
            if (cookieTabLabel) cookieTabLabel.textContent = 'Cookie settings';
          }
        }
      );
    };

    loadPrivacyApi();
  }
});